const getConfig = () => {
  const runtime = window?.runtimeConfig || {}

  return {
    // API Configuration
    socketUrl: runtime.VUE_APP_SOCKET_URL || process.env.VUE_APP_SOCKET_URL || '',
    apiBaseUrl: runtime.VUE_APP_API_URL || process.env.VUE_APP_API_URL,
    mapBoxPK: runtime.VUE_APP_MAPBOX_PK || process.env.VUE_APP_MAPBOX_PK || '',
    thtcApiKey: runtime.VUE_APP_THTC_API_KEY || process.env.VUE_APP_THTC_API_KEY || '',
    keyCloakURL: runtime.VUE_APP_KEYCLOAK_URL || process.env.VUE_APP_KEYCLOAK_URL || '',
    keyCloakClientId:
      runtime.VUE_APP_KEYCLOAK_CLIENT_ID || process.env.VUE_APP_KEYCLOAK_CLIENT_ID || '',
    googleMapApiKey:
      runtime.VUE_APP_GOOGLE_MAPS_API_KEY || process.env.VUE_APP_GOOGLE_MAPS_API_KEY || '',
    // Add your custom config here
  }
}

const config = getConfig()

// Freeze config to prevent modifications
export default Object.freeze(config)

// Optional: Export individual values for convenience
export const { apiBaseUrl, mapBoxPK, thtcAPIKey, keyCloakURL, keyCloakClientId, googleMapApiKey } =
  config
